import { render, staticRenderFns } from "./Rechazar_Fichero_Mercado.vue?vue&type=template&id=fb5be534&scoped=true"
import script from "./Rechazar_Fichero_Mercado.vue?vue&type=script&lang=js"
export * from "./Rechazar_Fichero_Mercado.vue?vue&type=script&lang=js"
import style0 from "./Rechazar_Fichero_Mercado.vue?vue&type=style&index=0&id=fb5be534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5be534",
  null
  
)

export default component.exports